<template>
  <el-dialog 
      v-el-drag-dialog 
      :visible.sync="dialogVisible" 
      class="adaptationModal" 
      title="打印" 
      width="600px">
    <div id="print">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <td rowspan="3" style="width: 110px">
            <div id="qrCode" align="center"/>
          </td>
          <td colspan="2">{{parentPName + "(" + warehouseNo + ")"}}</td>
        </tr>
        <tr>
          <td colspan="2">{{parentName + "(" + repositoryNo + ")"}}</td>
        </tr>
        <tr>
          <td colspan="2">{{name + "(" + other + ")"}}</td>
        </tr>
      </table>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        dialogVisible: false,
        warehouseNo: "",
        repositoryNo: "",
        other: "",
        name: "",
        parentName: "",
        parentPName: "",
      };
    },

    methods: {
      open(row) {
        this.warehouseNo = row.other.substring(0, 3);
        this.repositoryNo = row.other.split("-")[0];
        this.other = row.other;
        this.dialogVisible = true;
        this.$nextTick(() => {
          document.getElementById("qrCode").innerHTML = "";
          this.bindQRCode(row.other);
          this.getInfoById(row.id);
        });
      },

      bindQRCode(row) {
        new QRCode(document.getElementById("qrCode"), {
          text: row,
          width: 90,
          height: 90,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        window.location.reload();
        return false;
      },

      getInfoById(id) {
        this.$http.get("basic", `warehouses/getByIdWarehouseVo/${id}`).then((res) => {
          if (res.success) {
            this.name = res.data.name;
            this.parentName = res.data.parentName;
            this.parentPName = res.data.parentPName;
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
#print {
  width: 76mm;
  height: 36mm;
  margin: 0 auto;
  margin-top: 1.5mm;
  page-break-before: always;
  font-size: 10px;
  table {
    width: 100%;
    height: 100%;
    td {
      border: 1px solid #111;
      border-bottom: 0;
      border-right: 0;
      padding: 1mm;
      box-sizing: border-box;
    }
    tr:first-child td:first-child {
      border-bottom: 1px solid #111;
    }
    tr:last-child td {
      border-bottom: 1px solid #111;
    }
    tr td:last-child {
      border-right: 1px solid #111;
    }
  }
}
</style>
